import React from 'react';
import { Badge } from '../components/Badge';
import { DevSettings } from './DevSettings';
import { useInstance } from '@meraki-internal/react-dependency-injection';

export const DevFlagsBadge: React.FC = () => {

    const devSettings = useInstance(DevSettings);

    const hasAnyDevFlags =
        devSettings.enableHexagonTools ||
        devSettings.eligibleForTrial ||
        devSettings.enableWebBypassUpgrade ||
        devSettings.useRealPaymentsEvenIfBypassEnabled ||
        devSettings.showVeryShortExpiration ||
        devSettings.disableToastAutoDismiss ||
        devSettings.showApptRecordingNotificationBtn ||
        devSettings.recordingShortPauseAutoSave ||
        devSettings.disableRecordingContextStart ||
        devSettings.enableUploadRecording ||
        devSettings.simulateRecordingSuccess ||
        devSettings.ignoreShortRecordingMessages ||
        devSettings.showTaskNotificationTestBtns;

    if (!hasAnyDevFlags) {
        return null;
    }

    return (
        <div style={{zIndex: 9999999, position: 'fixed', top: -18, right: 16}}>
            <Badge size="small" color="warning" saturated>DEV FLAGS</Badge>
        </div>
    );
};
